export default "__VITE_ASSET__BV_0Nmr___"